import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-36075319__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Gesundheit", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-36075319__cls-1{fill:none}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "m86.17 59.55 19.67 39.34 7.36-14.72h45.55c1.34-4.49 2.09-9.01 2.09-13.52 0-19.48-15.85-35.34-35.34-35.34-10.11 0-19.77 4.38-26.5 12.02l-3 3.41-3-3.41c-6.73-7.64-16.39-12.02-26.5-12.02-19.48 0-35.34 15.85-35.34 35.34 0 4.51.75 9.03 2.09 13.52h40.61l12.31-24.61Z",
      class: "i-36075319__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M96 156.15c9.38-6.56 46.18-33.67 59.76-63.99h-37.62l-12.31 24.61-19.67-39.34-7.36 14.72H36.23c13.58 30.33 50.38 57.43 59.77 63.99Z",
      class: "i-36075319__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M12 92.17h15.57c15.07 38.22 63.8 70.58 66.24 72.18l2.19 1.44 2.19-1.44c.72-.47 17.74-11.71 35.03-28.73 15.37-15.13 25.81-29.67 31.23-43.45h15.54v-8h-12.93c1.18-4.6 1.77-9.11 1.77-13.52 0-23.9-19.44-43.34-43.34-43.34-10.97 0-21.51 4.2-29.5 11.65-7.99-7.45-18.53-11.65-29.5-11.65-23.9 0-43.34 19.44-43.34 43.34 0 4.53.64 9.05 1.79 13.52H12zm84 63.99c-9.38-6.56-46.19-33.66-59.77-63.99H78.8l7.36-14.72 19.67 39.34 12.31-24.61h37.62c-13.59 30.31-50.38 57.42-59.76 63.99ZM31.16 70.65c0-19.48 15.85-35.34 35.34-35.34 10.11 0 19.77 4.38 26.5 12.02l3 3.41 3-3.41c6.73-7.64 16.39-12.02 26.5-12.02 19.48 0 35.34 15.85 35.34 35.34 0 4.51-.75 9.03-2.09 13.52H113.2l-7.36 14.72-19.67-39.34-12.31 24.61H33.25c-1.33-4.49-2.09-9.01-2.09-13.52Z",
      style: {"fill":"#2d2d2d"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "heartLine"}) } }